import {
  FieldQueryOptions,
  ProgramEngagementStatus,
  ProgramTask,
  ProgramTaskRole,
  TaskDataUpdates,
  UserId,
} from '@cibo/core'
import { usePaginatedFields } from '@cibo/landmanager'
import { EngagementRouteParams } from '@cibo/ui'
import { UseQueryResult } from '@tanstack/react-query'
import { createContext, useContext } from 'react'
import { TaskDataModel } from '../../features/ProgramEngagementPlayer/models/TaskDataModel'
import { useProgramEngagement, useProgramModel } from '../../queries'

type ProgramEngagementState = EngagementRouteParams & {
  basePath: string
  program: ReturnType<typeof useProgramModel>
  ownerName: string

  taskData: UseQueryResult<TaskDataModel, Error>
  taskConfig?: ProgramTask
  dataEntryDetail(spec: { parentTraitId: string; traitId: string }): any

  engagement: ReturnType<typeof useProgramEngagement>
  /** @deprecated - prefer using `engagement.refresh()` */
  refreshEngagement(): void

  fieldModels: ReturnType<typeof usePaginatedFields>
  baseFieldsQuery?: FieldQueryOptions

  continueFunction: (() => void) | undefined
  setContinueFunction(f: ((args: any) => void) | undefined): void

  userRole: ProgramTaskRole
  userId?: UserId
  programId: string
  stepStatus?: ProgramEngagementStatus
  taskStatus?: ProgramEngagementStatus
  taskEditorParams?: any
  _TEST_ONLY_overrideSave?: (updates: TaskDataUpdates) => void
}

const DEFAULT_VALUES = {
  basePath: '',
  ownerName: '',
  engagement: {} as ProgramEngagementState['engagement'],
  userRole: 'participant',
  program: {} as ProgramEngagementState['program'],
  taskData: {} as ProgramEngagementState['taskData'],
  taskConfig: {} as ProgramEngagementState['taskConfig'],
  continueFunction: undefined,
  setContinueFunction: () => console.log('default setContinueFunction()'),
  refreshEngagement: () => console.log('default refreshEngagement()'),
  refreshFields: () => console.log('default refreshFields()'),
  dataEntryDetail: () => console.log('default dataEntryDetail()'),
  fieldModels: {} as ProgramEngagementState['fieldModels'],
  programId: '',
} as ProgramEngagementState

export const ProgramEngagementContext = createContext<ProgramEngagementState>(DEFAULT_VALUES)
ProgramEngagementContext.displayName = 'ProgramEngagementContext'

export const useProgramEngagementContext = () => useContext(ProgramEngagementContext)
